import { rightArrowIcon } from 'constants/icons';
import { Link } from 'react-router-dom';
import { displayMonth } from 'utils/formatTime';
export default function Reminders({ imgSrc, deadline, description, viewDetailsLink }) {
  return (
    <div className="reminders-content">
      <div className="img-wrap">
        <img
          loading="lazy"
          src={imgSrc}
          alt="Resume learning"
        />
      </div>
      <div className="info-wrap">
        <span>Deadline:{displayMonth(deadline)}</span>
        {description && <p dangerouslySetInnerHTML={{ __html: description }} />}
        <Link
          className="view-details"
          to={viewDetailsLink}
        >
          View details {rightArrowIcon}
        </Link>
      </div>
    </div>
  );
}
